import React, { Component } from 'react';
import Sucursales from './Sucursales';
import ModelosLiquidacion from './ModelosLiquidacion';
import GruposAfinidad from './GruposAfinidad';
import LimitesCompra from './LimitesCompra';
import ModalidadDistribucionLimiteTarjeta from './ModalidadDistribucionLimiteTarjeta';
import LimiteFinanciacion from './LimiteFinanciacion';
import LimiteDefectoTarjeta from './LimiteDefectoTarjeta';
import FactorLimiteCompraCuotas from './FactorLimiteCompraCuotas';
import Cartera from './Cartera';
import Agrupamientos from './Agrupamientos';
import FormasPago from './FormasPago';
import FormaPagoDebitoCuenta from "./FormaPagoDebitoCuenta";
import FormaPagoSucursal from "./FormaPagoSucursal";
import FormaPagoCuentaBancaria from "./FormaPagoCuentaBancaria";
import LineasPrestamo from './LineasPrestamo';
import CategoriasAtm from './CategoriasAtm';
import CanalVenta from './CanalVenta';
import CodigoPlanta from './CodigoPlanta';
import DenominacionCuenta from './DenominacionCuenta';
import DescripcionCuenta from './DescripcionCuenta';
import DomicilioCorrespondencia from './DomicilioCorrespondencia';
import DomicilioParticular from './DomicilioParticular';
import Producto from './Producto';
import Promotor from './Promotor';
import BajaPreguntaConfirmacion from './BajaCuenta/Baja/BajaPreguntaConfirmacion';
import BajaMotivoComentario from './BajaCuenta/Baja/BajaMotivoComentario';
import ConfirmacionBaja from './BajaCuenta/Confirmacion/ConfirmacionBaja';
import Dialog from 'rc-dialog';
//import ModalPagosRegistrados from './ModalPagosRegistrados';

class Body extends Component {
    constructor(props) {
        super(props)
        this.openModalBajaCuenta = this.props.funciones.openModalBajaCuenta.bind(this);
        this.closeModalBajaCuenta = this.props.funciones.closeModalBajaCuenta.bind(this);

        this.state = { modalBajaCuenta: false, step: 0 };
    }

    toggleModalBajaCuenta() {
        this.setState({ modalBajaCuenta: !this.state.modalBajaCuenta, step: 0 });
    }

    toggleModalConfirmacionBaja(nroStep) {
        if (nroStep == 2) {
            this.props.funciones.realizarBajaCuentaTarjeta();
        }
        this.setState({ step: nroStep });
    }

    goToBajaCuenta(cuentaTarjetaEstadoId) {
        let nroStep = 0;
        let estadoModal = true;
        switch (cuentaTarjetaEstadoId) {
            case 3: //Operativa
                nroStep = 1;
                break;
            case 6: //Dada de Baja
                nroStep = -1;
                estadoModal = false;
                break;
            case 7: //En Proceso de Baja
                nroStep = 2;
                break;
        }
        this.setState({ modalBajaCuenta: estadoModal, step: nroStep });
    }

    render() {
        let data = this.props.data.cuentaDatos;
        let dataCompleto = this.props.data;
        let numeroCuenta = data.CuentaDenominacion + " - " + data.CuentaTarjetaNumero;

        //TODO: En la obtencion de datos colocar el 'Saldo No Vencido'
        let saldoNoVencido = 0

        let cuentaTarjetaEstadoId = data.CuentaTarjetaEstadoId;
        let saldoTotal = data.bajaCuentaData.bajaCuenta12.SaldoTotal;

        /*Busco el tipo de forma de pago para la cuenta*/
        const novedadFRMPG = dataCompleto.novedadesCuentaDatos.find((ncd) => ncd.NovedadCampoCodigo == "FRMPG_CUEN");
        let formaPagoIdAux;
        if (novedadFRMPG) {
            formaPagoIdAux = novedadFRMPG.ValorNovedad;
        } else {
            formaPagoIdAux = data.FormaPagoId;
        }
        let formaPagoEncontradaAux = data.accountData.GET_FORMA_PAGO.find(x => x.Id == formaPagoIdAux);
        if (!formaPagoEncontradaAux) {
            formaPagoEncontradaAux = { EsDebitoEnCuenta: false }
        }
        /*fin busqueda forma de pago*/

        let nombreBotonBaja = undefined;
        switch (cuentaTarjetaEstadoId) {
            case 3:
                nombreBotonBaja = "Baja de Cuenta";
                break;
            case 6:
                nombreBotonBaja = "Dada de Baja";
                break;
            case 7:
                nombreBotonBaja = "En Proceso de Baja";
                break;
        }

        let modal = undefined;
        let title = undefined;
        let body = undefined;
        let footer = undefined;
        switch (this.state.step) {
            case 0: //Baja (pregunta de confirmación)
                title = "Baja Cuenta: " + numeroCuenta;
                body = <BajaPreguntaConfirmacion bajaCuentaData={data.bajaCuentaData}
                    numeroCuenta={numeroCuenta} />
                footer = <div>
                    <button
                        type="button"
                        className="btn btn-cta"
                        key="acept"
                        onClick={() => this.toggleModalConfirmacionBaja(2)}>Aceptar</button>
                    <button
                        type="button"
                        className="btn btn-default"
                        key="cancel"
                        onClick={() => this.toggleModalBajaCuenta()}>Cancelar</button>
                </div>
                break;
            case 1: //Baja (motivo y comentarios)
                title = "Baja Cuenta: " + numeroCuenta;
                body = <BajaMotivoComentario bajaCuentaData={data.bajaCuentaData}
                    saldoNoVencido={saldoNoVencido}
                    saldoTotal={saldoTotal}
                    valorTxtArea={dataCompleto.valorTxtArea}
                    valorSelect={this.props.funciones.valorSelect}
                    valorTextArea={this.props.funciones.valorTextArea}
                    changeCheckSolicitarCaidaCuotas={this.props.funciones.changeCheckSolicitarCaidaCuotas} />
                footer = <div>
                    <button
                        type="button"
                        className="btn btn-cta"
                        key="acept"
                        onClick={() => this.toggleModalConfirmacionBaja(0)}>Aceptar</button>
                    <button
                        type="button"
                        className="btn btn-default"
                        key="cancel"
                        onClick={() => this.toggleModalBajaCuenta()}>Cancelar</button>
                </div>
                break;
            case 2: //Confirmacion de baja.
                title = "Confirmación de Baja de Cuenta: " + numeroCuenta;
                body = <ConfirmacionBaja saldoTotal={saldoTotal}
                    numeroCuenta={data.CuentaTarjetaNumero}
                    bajaId={dataCompleto.bajaId}
                    executionContext={this.props.executionContext} />
                footer = <div>
                    <button
                        type="button"
                        className="btn btn-cta"
                        key="acept"
                        onClick={() => this.toggleModalBajaCuenta()}>Aceptar</button>
                </div>
                break;
            default:
                break;
        }

        {/*Se quita 'animation' por interaccion entre mismo modal y state, sino solapa al cambiar */ }
        modal = <Dialog
            visible={this.state.modalBajaCuenta}
            onClose={() => this.toggleModalBajaCuenta()}
            animation=""
            maskAnimation="fade"
            style={{
                width: 679
            }}
            className="saldos-resumenes"
            title={title}
            footer={footer}>{body}</Dialog>

        return (
            <div className="row top-separator-xs">

                {modal}

                <div className="col-xs-12 right">
                    <button id="btnLimites" className="btn btn-secondary" type="button" onClick={() => this.goToBajaCuenta(cuentaTarjetaEstadoId)}>{nombreBotonBaja}</button>
                </div>

                <div className="col-xs-12">

                    <Producto data={data} />

                    <DescripcionCuenta data={data} />

                    <DenominacionCuenta data={data} dataCompleto={dataCompleto} codigoNovedad="DENOM_CUEN" form={this.props.form}

                        actualizarNovedadEstado={this.props.funciones.actualizarNovedadEstado}
                        cancelar={this.props.funciones.cancelar}
                        changeInput={this.props.funciones.changeInput}
                        estadoEdicion={this.props.funciones.estadoEdicion}
                        guardarNovedad={this.props.funciones.guardarNovedad}
                        mostrarModal={() => this.props.funciones.mostrarModal(true, "Denominación de la cuenta (para los archivos)", dataCompleto.entidadTipo, "DENOM_CUEN", data.CuentaTarjetaId)} />

                    <CodigoPlanta data={data} dataCompleto={dataCompleto} codigoNovedad="CODPL_CUEN" form={this.props.form}

                        actualizarNovedadEstado={this.props.funciones.actualizarNovedadEstado}
                        cancelar={this.props.funciones.cancelar}
                        changeInput={this.props.funciones.changeInput}
                        estadoEdicion={this.props.funciones.estadoEdicion}
                        guardarNovedad={this.props.funciones.guardarNovedad}
                        mostrarModal={() => this.props.funciones.mostrarModal(true, "Código de planta", dataCompleto.entidadTipo, "CODPL_CUEN", data.CuentaTarjetaId)} />

                    <Sucursales
                        codigoNovedad="SUCUR_CUEN"
                        cuentaTarjetaId={data.CuentaTarjetaId}
                        data={{ sucursalId: data.SucursalId, sucursalCodigo: data.SucursalCodigo }}
                        esNovedadEditada={dataCompleto.esNovedadEditada.find(x => x.campoCodigo == "SUCUR_CUEN").editado}
                        funcionesDelUsuario={dataCompleto.funcionesDelUsuario}
                        novedades={(dataCompleto.novedadesCuentaDatos || []).filter(n => n.NovedadCampoCodigo == "SUCUR_CUEN")}
                        seEstaEditando={dataCompleto.seEstaEditando}
                        sucursales={data.accountData.GET_ALL_SUCURSAL}
                        cuentaTarjetaEstadoId={data.CuentaTarjetaEstadoId}

                        actualizarNovedadEstado={this.props.funciones.actualizarNovedadEstado}
                        cancelar={this.props.funciones.cancelar}
                        estadoEdicion={this.props.funciones.estadoEdicion}
                        guardarNovedad={this.props.funciones.guardarNovedad}
                        mostrarModal={() => this.props.funciones.mostrarModal(true, "Sucursales", dataCompleto.entidadTipo, "SUCUR_CUEN", data.CuentaTarjetaId)}
                        selectCombo={this.props.funciones.selectCombo} />

                    <ModelosLiquidacion
                        codigoNovedad="MODLI_CUEN"
                        cuentaTarjetaId={data.CuentaTarjetaId}
                        data={{ modeloLiquidacionId: data.ModeloLiquidacionId, modeloLiquidacionCodigo: data.ModeloLiquidacionCodigo }}
                        esNovedadEditada={dataCompleto.esNovedadEditada.find(x => x.campoCodigo == "MODLI_CUEN").editado}
                        funcionesDelUsuario={dataCompleto.funcionesDelUsuario}
                        novedades={(dataCompleto.novedadesCuentaDatos || []).filter(n => n.NovedadCampoCodigo == "MODLI_CUEN")}
                        seEstaEditando={dataCompleto.seEstaEditando}
                        modelosLiquidacion={data.accountData.GET_MODELO_LIQUIDACION}
                        cuentaTarjetaEstadoId={data.CuentaTarjetaEstadoId}

                        actualizarNovedadEstado={this.props.funciones.actualizarNovedadEstado}
                        cancelar={this.props.funciones.cancelar}
                        estadoEdicion={this.props.funciones.estadoEdicion}
                        guardarNovedad={this.props.funciones.guardarNovedad}
                        mostrarModal={() => this.props.funciones.mostrarModal(true, "Modelos de liquidación", dataCompleto.entidadTipo, "MODLI_CUEN", data.CuentaTarjetaId)}
                        selectCombo={this.props.funciones.selectCombo} />

                    <GruposAfinidad
                        codigoNovedad="GRUPA_CUEN"
                        cuentaTarjetaId={data.CuentaTarjetaId}
                        data={{ grupoAfinidadId: data.GrupoAfinidadId, grupoAfinidadcodigo: data.GrupoAfinidadCodigo }}
                        esNovedadEditada={dataCompleto.esNovedadEditada.find(x => x.campoCodigo == "GRUPA_CUEN").editado}
                        funcionesDelUsuario={dataCompleto.funcionesDelUsuario}
                        novedades={(dataCompleto.novedadesCuentaDatos || []).filter(n => n.NovedadCampoCodigo == "GRUPA_CUEN")}
                        seEstaEditando={dataCompleto.seEstaEditando}
                        gruposAfinidad={data.accountData.GET_GRUPO_AFINIDAD}
                        cuentaTarjetaEstadoId={data.CuentaTarjetaEstadoId}

                        actualizarNovedadEstado={this.props.funciones.actualizarNovedadEstado}
                        cancelar={this.props.funciones.cancelar}
                        estadoEdicion={this.props.funciones.estadoEdicion}
                        guardarNovedad={this.props.funciones.guardarNovedad}
                        mostrarModal={() => this.props.funciones.mostrarModal(true, "Grupo de afinidad", dataCompleto.entidadTipo, "GRUPA_CUEN", data.CuentaTarjetaId)}
                        selectCombo={this.props.funciones.selectCombo} />

                    <LimitesCompra data={data} dataCompleto={dataCompleto} codigoNovedad="LIMCO_CUEN" />

                    <ModalidadDistribucionLimiteTarjeta data={data} form={this.props.form} />

                    {data.ModalidadDistribucionLimiteId > 1 &&
                        <LimiteDefectoTarjeta data={data} dataCompleto={dataCompleto} codigoNovedad="LIDFT_CUEN" form={this.props.form}

                            actualizarNovedadEstado={this.props.funciones.actualizarNovedadEstado}
                            cancelar={this.props.funciones.cancelar}
                            changeInput={this.props.funciones.changeInput}
                            estadoEdicion={this.props.funciones.estadoEdicion}
                            guardarNovedad={this.props.funciones.guardarNovedad}
                            mostrarModal={() => this.props.funciones.mostrarModal(true, "Límite por defecto para cada tarjeta", dataCompleto.entidadTipo, "LIDFT_CUEN", data.CuentaTarjetaId)} />}

                    <LimiteFinanciacion data={data} dataCompleto={dataCompleto} codigoNovedad="LIMFI_CUEN" form={this.props.form}

                        actualizarNovedadEstado={this.props.funciones.actualizarNovedadEstado}
                        cancelar={this.props.funciones.cancelar}
                        changeInput={this.props.funciones.changeInput}
                        estadoEdicion={this.props.funciones.estadoEdicion}
                        guardarNovedad={this.props.funciones.guardarNovedad}
                        mostrarModal={() => this.props.funciones.mostrarModal(true, "Límite de financiación", dataCompleto.entidadTipo, "LIMFI_CUEN", data.CuentaTarjetaId)} />

                    <FactorLimiteCompraCuotas data={data} dataCompleto={dataCompleto} codigoNovedad="FLCC_CUEN" form={this.props.form}

                        actualizarNovedadEstado={this.props.funciones.actualizarNovedadEstado}
                        cancelar={this.props.funciones.cancelar}
                        changeInput={this.props.funciones.changeInput}
                        estadoEdicion={this.props.funciones.estadoEdicion}
                        guardarNovedad={this.props.funciones.guardarNovedad}
                        mostrarModal={() => this.props.funciones.mostrarModal(true, "Factor de límite de compra en cuotas (FLCC)", dataCompleto.entidadTipo, "FLCC_CUEN", data.CuentaTarjetaId)} />

                    <Cartera data={data} />

                    <Agrupamientos
                        codigoNovedad="AGRUP_CUEN"
                        cuentaTarjetaId={data.CuentaTarjetaId}
                        data={{ agrupamientoVisaId: data.AgrupamientoVisaId, agrupamientoVisaCodigo: data.AgrupamientoVisaCodigo }}
                        esNovedadEditada={dataCompleto.esNovedadEditada.find(x => x.campoCodigo == "AGRUP_CUEN").editado}
                        funcionesDelUsuario={dataCompleto.funcionesDelUsuario}
                        novedades={(dataCompleto.novedadesCuentaDatos || []).filter(n => n.NovedadCampoCodigo == "AGRUP_CUEN")}
                        seEstaEditando={dataCompleto.seEstaEditando}
                        agrupamientos={data.accountData.GET_AGRUPAMIENTO}
                        cuentaTarjetaEstadoId={data.CuentaTarjetaEstadoId}

                        actualizarNovedadEstado={this.props.funciones.actualizarNovedadEstado}
                        cancelar={this.props.funciones.cancelar}
                        estadoEdicion={this.props.funciones.estadoEdicion}
                        guardarNovedad={this.props.funciones.guardarNovedad}
                        mostrarModal={() => this.props.funciones.mostrarModal(true, "Agrupamientos", dataCompleto.entidadTipo, "AGRUP_CUEN", data.CuentaTarjetaId)}
                        selectCombo={this.props.funciones.selectCombo} />

                    <FormasPago
                        codigoNovedad="FRMPG_CUEN"
                        cuentaTarjetaId={data.CuentaTarjetaId}
                        data={{ formaPagoId: data.FormaPagoId, formaPagocodigo: data.FormaPagoCodigo }}
                        esNovedadEditada={dataCompleto.esNovedadEditada.find(x => x.campoCodigo == "FRMPG_CUEN").editado}
                        funcionesDelUsuario={dataCompleto.funcionesDelUsuario}
                        novedades={(dataCompleto.novedadesCuentaDatos || []).filter(n => n.NovedadCampoCodigo == "FRMPG_CUEN")}
                        seEstaEditando={dataCompleto.seEstaEditando}
                        formasPago={data.accountData.GET_FORMA_PAGO}
                        cuentaTarjetaEstadoId={data.CuentaTarjetaEstadoId}

                        actualizarNovedadEstado={this.props.funciones.actualizarNovedadEstado}
                        cancelar={this.props.funciones.cancelar}
                        estadoEdicion={this.props.funciones.estadoEdicion}
                        guardarNovedad={this.props.funciones.guardarNovedad}
                        mostrarComponente={this.props.funciones.mostrarComponente}
                        mostrarModal={() => this.props.funciones.mostrarModal(true, "Forma de Pago", dataCompleto.entidadTipo, "FRMPG_CUEN", data.CuentaTarjetaId)}
                        selectCombo={this.props.funciones.selectCombo} />

                    {formaPagoEncontradaAux.EsDebitoEnCuenta &&
                        <div>
                            <FormaPagoDebitoCuenta
                                codigoNovedad="FRMDB_CUEN"
                                cuentaTarjetaId={data.CuentaTarjetaId}
                                data={data.FormaDebitoId}
                                esNovedadEditada={dataCompleto.esNovedadEditada.find(x => x.campoCodigo == "FRMDB_CUEN").editado}
                                funcionesDelUsuario={dataCompleto.funcionesDelUsuario}
                                novedades={(dataCompleto.novedadesCuentaDatos || []).filter(n => n.NovedadCampoCodigo == "FRMDB_CUEN")}
                                seEstaEditando={dataCompleto.seEstaEditando}
                                formasPagoDebito={data.accountData.GET_FORMA_DEBITO}
                                cuentaTarjetaEstadoId={data.CuentaTarjetaEstadoId}

                                actualizarNovedadEstado={this.props.funciones.actualizarNovedadEstado}
                                cancelar={this.props.funciones.cancelar}
                                estadoEdicion={this.props.funciones.estadoEdicion}
                                guardarNovedad={this.props.funciones.guardarNovedad}
                                mostrarComponente={this.props.funciones.mostrarComponente}
                                mostrarModal={() => this.props.funciones.mostrarModal(true, "Importe a debitar", dataCompleto.entidadTipo, "FRMDB_CUEN", data.CuentaTarjetaId)}
                                selectCombo={this.props.funciones.selectCombo} />

                            <FormaPagoSucursal data={data} dataCompleto={dataCompleto} codigoNovedad="SUCUE_CUEN"

                                actualizarNovedadEstado={this.props.funciones.actualizarNovedadEstado}
                                cancelar={this.props.funciones.cancelar}
                                estadoEdicion={this.props.funciones.estadoEdicion}
                                guardarNovedad={this.props.funciones.guardarNovedad}
                                mostrarComponente={this.props.funciones.mostrarComponente}
                                mostrarModal={() => this.props.funciones.mostrarModal(true, "Sucursal de la cuenta", dataCompleto.entidadTipo, "SUCUE_CUEN", data.CuentaTarjetaId)}
                                selectCombo={this.props.funciones.selectCombo} />

                            <FormaPagoCuentaBancaria data={data} dataCompleto={dataCompleto} codigoNovedad="CUEBC_CUEN"

                                actualizarNovedadEstado={this.props.funciones.actualizarNovedadEstado}
                                cancelar={this.props.funciones.cancelar}
                                estadoEdicion={this.props.funciones.estadoEdicion}
                                guardarNovedad={this.props.funciones.guardarNovedad}
                                mostrarComponente={this.props.funciones.mostrarComponente}
                                mostrarModal={() => this.props.funciones.mostrarModal(true, "Cuenta", dataCompleto.entidadTipo, "CUEBC_CUEN", data.CuentaTarjetaId)}
                                selectCombo={this.props.funciones.selectCombo} />
                        </div>
                    }


                    <DomicilioParticular
                        data={data}
                        dataCompleto={dataCompleto}
                        codigoNovedad="DOMPA_CUEN"
                        form={this.props.form}

                        actualizarNovedadEstado={this.props.funciones.actualizarNovedadEstado}
                        cancelar={this.props.funciones.cancelar}
                        estadoEdicion={this.props.funciones.estadoEdicion}
                        guardarNovedad={this.props.funciones.guardarNovedad}
                        guardarCampo={this.props.funciones.guardarCampo}
                        mostrarModal={() => this.props.funciones.mostrarModal(true, "Domicilio Particular", dataCompleto.entidadTipo, "DOMPA_CUEN", data.CuentaTarjetaId)}
                        selectCombo={this.props.funciones.selectCombo} />

                    {dataCompleto.domiciliosService &&
                        <DomicilioCorrespondencia
                            data={this.props.data}
                            dataCompleto={dataCompleto}
                            codigoNovedad="DOMCO_CUEN"
                            form={this.props.form}

                            actualizarNovedadEstados={this.props.funciones.actualizarNovedadEstados}
                            cancelar={this.props.funciones.cancelar}
                            changeInput={this.props.funciones.changeInput}
                            estadoEdicion={this.props.funciones.estadoEdicion}
                            guardarNovedades={this.props.funciones.guardarNovedades}
                            mostrarModal={() => this.props.funciones.mostrarModal(true, "Domicilio para correspondencia", dataCompleto.entidadTipo, "DOMCO_CUEN", data.CuentaTarjetaId)}
                            selectCombo={this.props.funciones.selectCombo} />}

                    <Promotor
                        codigoNovedad="PROMO_CUEN"
                        cuentaTarjetaId={data.CuentaTarjetaId}
                        data={data.PromotorId}
                        esNovedadEditada={dataCompleto.esNovedadEditada.find(x => x.campoCodigo == "PROMO_CUEN").editado}
                        funcionesDelUsuario={dataCompleto.funcionesDelUsuario}
                        novedades={(dataCompleto.novedadesCuentaDatos || []).filter(n => n.NovedadCampoCodigo == "PROMO_CUEN")}
                        seEstaEditando={dataCompleto.seEstaEditando}
                        promotores={data.accountData.GET_PROMOTOR}
                        cuentaTarjetaEstadoId={data.CuentaTarjetaEstadoId}

                        actualizarNovedadEstado={this.props.funciones.actualizarNovedadEstado}
                        cancelar={this.props.funciones.cancelar}
                        estadoEdicion={this.props.funciones.estadoEdicion}
                        guardarNovedad={this.props.funciones.guardarNovedad}
                        mostrarModal={() => this.props.funciones.mostrarModal(true, "Promotor", dataCompleto.entidadTipo, "PROMO_CUEN", data.CuentaTarjetaId)}
                        selectCombo={this.props.funciones.selectCombo} />

                    <CanalVenta data={data} dataCompleto={dataCompleto} codigoNovedad="CANVT_CUEN" form={this.props.form}

                        actualizarNovedadEstado={this.props.funciones.actualizarNovedadEstado}
                        cancelar={this.props.funciones.cancelar}
                        changeInput={this.props.funciones.changeInput}
                        estadoEdicion={this.props.funciones.estadoEdicion}
                        guardarNovedad={this.props.funciones.guardarNovedad}
                        mostrarModal={() => this.props.funciones.mostrarModal(true, "Canal de Venta", dataCompleto.entidadTipo, "CANVT_CUEN", data.CuentaTarjetaId)} />

                    <LineasPrestamo
                        codigoNovedad="LINPR_CUEN"
                        cuentaTarjetaId={data.CuentaTarjetaId}
                        data={{ lineaPrestamoVisaId: data.LineaPrestamoVisaId, lineaPrestamoVisaCoigo: data.LineaPrestamoVisaCodigo }}
                        esNovedadEditada={dataCompleto.esNovedadEditada.find(x => x.campoCodigo == "LINPR_CUEN").editado}
                        funcionesDelUsuario={dataCompleto.funcionesDelUsuario}
                        novedades={(dataCompleto.novedadesCuentaDatos || []).filter(n => n.NovedadCampoCodigo == "LINPR_CUEN")}
                        seEstaEditando={dataCompleto.seEstaEditando}
                        lineasPrestamo={data.accountData.GET_LINEA_PRESTAMO}
                        cuentaTarjetaEstadoId={data.CuentaTarjetaEstadoId}

                        actualizarNovedadEstado={this.props.funciones.actualizarNovedadEstado}
                        cancelar={this.props.funciones.cancelar}
                        estadoEdicion={this.props.funciones.estadoEdicion}
                        guardarNovedad={this.props.funciones.guardarNovedad}
                        mostrarModal={() => this.props.funciones.mostrarModal(true, "Lineas de Prestamo", dataCompleto.entidadTipo, "LINPR_CUEN", data.CuentaTarjetaId)}
                        selectCombo={this.props.funciones.selectCombo} />

                    <CategoriasAtm
                        codigoNovedad="CATAT_CUEN"
                        cuentaTarjetaId={data.CuentaTarjetaId}
                        data={{ categoriaCajeroVisaId: data.CategoriaCajeroVisaId, categoriaCajeroVisaCodigo: data.CategoriaCajeroVisaCodigo }}
                        esNovedadEditada={dataCompleto.esNovedadEditada.find(x => x.campoCodigo == "CATAT_CUEN").editado}
                        funcionesDelUsuario={dataCompleto.funcionesDelUsuario}
                        novedades={(dataCompleto.novedadesCuentaDatos || []).filter(n => n.NovedadCampoCodigo == "CATAT_CUEN")}
                        seEstaEditando={dataCompleto.seEstaEditando}
                        categoriasATM={data.accountData.GET_CATEGORIA_CAJERO}
                        cuentaTarjetaEstadoId={data.CuentaTarjetaEstadoId}

                        actualizarNovedadEstado={this.props.funciones.actualizarNovedadEstado}
                        cancelar={this.props.funciones.cancelar}
                        estadoEdicion={this.props.funciones.estadoEdicion}
                        guardarNovedad={this.props.funciones.guardarNovedad}
                        mostrarModal={() => this.props.funciones.mostrarModal(true, "Categoría cajeros", dataCompleto.entidadTipo, "CATAT_CUEN", data.CuentaTarjetaId)}
                        selectCombo={this.props.funciones.selectCombo} />
                </div>
            </div>
        );
    }
}

export default Body;

